import PersonalForm from "./templates/personal-form";
import PersonalFormNew from "./templates/personal-form-new";
import MedicalExamDownload from "./templates/medical-exam-download";
import MedicalExamUpload from "./templates/medical-exam-upload";
import EducationProofUpload from "./templates/education-proof-upload";
import CandidateFeedbackForm from "./templates/candidate-feedback-form";
import NewEmployeeFeedbackForm from "./templates/new-employee-feedback-form";
import NewEmployeeAdaptationFeedbackForm from "./templates/new-employee-adaptation-feedback-form";
import OrientationDay from "./templates/orientation-day";
import WelcomeAtWork from "./templates/welcome-at-work";
import InnogyStyle from "./templates/innogy-style";
import InnogyIntroduction from "./templates/innogy-introduction";
import Article from "./templates/article";
import React from "react";
import BaseComponent from "../base-component";
import PropTypes from "prop-types";

class ContentUnitShow extends BaseComponent {
    render() {
        const contentUnit = this.props.assignment.content_unit;

        switch (contentUnit.type) {
            case 'ContentUnits::PersonalForm':                      return (<PersonalForm {...this.props}/>);
            case 'ContentUnits::PersonalFormNew':                   return (<PersonalFormNew {...this.props}/>);
            case 'ContentUnits::MedicalExamDownload':               return (<MedicalExamDownload {...this.props}/>);
            case 'ContentUnits::MedicalExamUpload':                 return (<MedicalExamUpload {...this.props}/>);
            case 'ContentUnits::EducationProofUpload':              return (<EducationProofUpload {...this.props}/>);
            case 'ContentUnits::CandidateFeedbackForm':             return (<CandidateFeedbackForm {...this.props}/>);
            case 'ContentUnits::NewEmployeeFeedbackForm':           return (<NewEmployeeFeedbackForm {...this.props}/>);
            case 'ContentUnits::NewEmployeeAdaptationFeedbackForm': return (<NewEmployeeAdaptationFeedbackForm {...this.props}/>);
            case 'ContentUnits::OrientationDay':                    return (<OrientationDay {...this.props}/>);
            case 'ContentUnits::WelcomeAtWork':                     return (<WelcomeAtWork {...this.props}/>);
            case 'ContentUnits::InnogyStyle':                       return (<InnogyStyle {...this.props}/>);
            case 'ContentUnits::InnogyIntroduction':                return (<InnogyIntroduction {...this.props}/>);

            default:                                                return (<Article {...this.props}/>);
        }
    };
}

// ContentUnitShow.propTypes = {
//     assignment: PropTypes.object.isRequired,
//     selectAssignment: PropTypes.func.isRequired,
//     markAsDone: PropTypes.func.isRequired,
//     assignmentAction: PropTypes.func.isRequired,
//     assignmentUpload: PropTypes.func.isRequired,
//     setNotification: PropTypes.func.isRequired,
//     clearNotifications: PropTypes.func.isRequired,
//     push: PropTypes.func.isRequired,
// };

export default ContentUnitShow;
